// @flow
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

const DocGenIcon = ({ className = '', height = 16, width = 16 }: SVGProps) => (
    <AccessibleSVG width={width} height={height} viewBox="0 0 16 16" role="img" className={className}>
        <path
            d="M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H9C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3H3Z"
            fill="#909090"
        />
        <path
            d="M5 8C5 7.44772 5.44772 7 6 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H6C5.44772 9 5 8.55228 5 8Z"
            fill="#909090"
        />
        <path
            d="M2 12C2 11.4477 2.44772 11 3 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H3C2.44772 13 2 12.5523 2 12Z"
            fill="#909090"
        />
    </AccessibleSVG>
);

export default DocGenIcon;
